import { LocalizedText } from '@mews/framework';
import { Identifiable } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { getCustomersByIds } from '@mews-commander/legacy-entities/src/ducks';
import EntityTable from '../../../../../entityManagement/components/EntityTable';
import { createPagedEntityTableConnect } from '../../../../../entityManagement';
import { CustomerLink } from '../../../../../../components';

const mapping = [
    {
        title: <LocalizedText textKey={TextKey.Customer} />,
        valueKey: 'name',
        render: ({ id }: Identifiable) => <CustomerLink id={id} />,
    },
    {
        title: <LocalizedText textKey={TextKey.Occupation} />,
        valueKey: 'occupation',
    },
    {
        title: <LocalizedText textKey={TextKey.Email} />,
        valueKey: 'email',
    },
];

const CustomerTable = EntityTable({ mapping });
// @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
export default createPagedEntityTableConnect(getCustomersByIds)(CustomerTable);
